import { Box } from '@mui/material';
import styled from 'styled-components';

export const WidgetContainer = styled(Box)`
  background-color: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.xl};
  font-family: ${({ theme }) => theme.fonts.body};
  height: auto;
  width: 100%;
  margin-bottom: ${({ theme }) => theme.spacing[4]};
  transition: box-shadow ${({ theme }) => theme.duration.fast} ${({ theme }) => theme.easing.easeOut};

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing[4]};
`;

export const SearchBarStyled = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.backgroundAlt};
  border: 1px solid ${({ theme, $focused }) =>
    $focused ? theme.colors.primary : theme.colors.border};
  border-radius: ${({ theme }) => theme.radii.full};
  padding: ${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]};
  margin: 0;
  width: 100%;
  transition:
    border-color ${({ theme }) => theme.duration.fast} ${({ theme }) => theme.easing.easeOut},
    box-shadow ${({ theme }) => theme.duration.fast} ${({ theme }) => theme.easing.easeOut};
  box-shadow: ${({ theme, $focused }) =>
    $focused ? `0 0 0 3px ${theme.colors.primaryGhost}` : 'none'};
`;
